import React, { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function MenuEmailDialog({ menu, onClose, onSent }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  if (!menu) return null;
  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/menus/${menu.id}/email`, { message });
      toast.success(data.message); onSent?.(); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSending(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="menu-email-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Mail className="h-5 w-5 text-primary" /> Menüyü E-posta ile Gönder</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground"><b>{menu.name}</b> PDF olarak atanan müşterilere gönderilecek:</p>
        <div className="flex flex-wrap gap-1.5" data-testid="menu-email-recipients">
          {menu.customers.length === 0 && <span className="text-sm text-destructive">Menüye atanmış müşteri yok</span>}
          {menu.customers.map((c) => <span key={c.id} className="rounded-full bg-muted px-2.5 py-0.5 text-xs">{c.short_name || c.name}</span>)}
        </div>
        <Textarea rows={3} placeholder="İsteğe bağlı mesaj…" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="menu-email-message" />
        <p className="text-xs text-muted-foreground">E-posta adresi kayıtlı olmayan müşteriler atlanır.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>İptal</Button>
          <Button onClick={send} disabled={sending || menu.customers.length === 0} data-testid="menu-email-send" className="gap-2">{sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Gönder</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
